import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

const AfterPaintContext = createContext(false);

/** Becomes true after the first animation frame so layout reads wait until paint. */
export function AfterPaintProvider({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const frame = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(frame);
  }, []);

  return <AfterPaintContext.Provider value={ready}>{children}</AfterPaintContext.Provider>;
}

export function useAfterPaint() {
  return useContext(AfterPaintContext);
}
